import { render, staticRenderFns } from "./inex.vue?vue&type=template&id=f4bb5322&scoped=true&"
import script from "./inex.vue?vue&type=script&lang=js&"
export * from "./inex.vue?vue&type=script&lang=js&"
import style0 from "./inex.vue?vue&type=style&index=0&id=f4bb5322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bb5322",
  null
  
)

export default component.exports